import { render, staticRenderFns } from "./OrdingDescript.vue?vue&type=template&id=16b1c2be&scoped=true"
import script from "./OrdingDescript.vue?vue&type=script&lang=js"
export * from "./OrdingDescript.vue?vue&type=script&lang=js"
import style0 from "./OrdingDescript.vue?vue&type=style&index=0&id=16b1c2be&prod&lang=scss&scoped=true"
import style1 from "./OrdingDescript.vue?vue&type=style&index=1&id=16b1c2be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b1c2be",
  null
  
)

export default component.exports